import { render, staticRenderFns } from "./LossAnasyleDetails.vue?vue&type=template&id=6cdee81c&scoped=true&"
import script from "./LossAnasyleDetails.vue?vue&type=script&lang=ts&"
export * from "./LossAnasyleDetails.vue?vue&type=script&lang=ts&"
import style0 from "./LossAnasyleDetails.vue?vue&type=style&index=0&id=6cdee81c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdee81c",
  null
  
)

export default component.exports